<form [formGroup]="registerForm">
    <app-custom-input
        [control]="registerForm.controls.firstName"
        placeholder="First Name"
        type="text"
        required="true"
        formControlName="firstName"
        label="First Name">
    </app-custom-input>
    <app-custom-input
        [control]="registerForm.controls.lastName"
        placeholder="Last Name"
        type="text"
        required="true"
        formControlName="lastName"
        label="Last Name">
    </app-custom-input>
    <app-custom-input
        [control]="registerForm.controls.email"
        placeholder="Email"
        type="email"
        required="true"
        formControlName="email"
        label="Email">
    </app-custom-input>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <app-custom-input
            [control]="registerForm.controls.password"
            placeholder="Password"
            type="password"
            required="true"
            formControlName="password"
            label="Password">
        </app-custom-input>
        <app-custom-input
            [control]="registerForm.controls.confirmPassword"
            placeholder="Confirm Password"
            type="password"
            required="true"
            formControlName="confirmPassword"
            label="Confirm Password">
        </app-custom-input>
    </div>

    <div class="flex justify-center pt-4">
        <app-turnstile
            [formControl]="registerForm.controls.captchaToken"
            theme="light"></app-turnstile>
    </div>

    @if (registerForm.controls['email'].errors?.emailExists) {
        <p class="mt-1 text-sm font-bold">
            Oops, there's already an account with this email.
        </p>
    }
    @if (registerForm.controls['email'].errors?.emailCheckUnavailable) {
        <p class="mt-1 text-sm font-bold">
            We couldn't check this email right now. Please try again later.
        </p>
    }
    @if (
        registerForm.controls['confirmPassword'].touched &&
        registerForm.controls['confirmPassword'].errors?.mustMatch
    ) {
        <p class="mt-1 text-sm font-bold">Passwords do not match</p>
    }
    @if (registrationErrorMessage()) {
        <p class="mt-1 text-sm font-bold text-red">
            {{ registrationErrorMessage() }}
        </p>
    }
    <app-save-button
        testId="registerButton"
        class="w-full"
        [showLoader]="isSubmittingForm()"
        (onClick)="onSubmit()"
        type="button"
        [additionalClasses]="['p-4 w-full mt-4 mb-2']">
        <span class="text-xl font-bold">Sign Up</span>
    </app-save-button>
</form>
